export default function EditorialSection() {
  const articles = [
    {
      title: 'Hipobuy Sheet 2026 Complete Guide',
      subtitle: 'Updated daily with new finds',
      url: '/hipobuy-spreadsheet-guide',
      isInternal: true,
      bgClass: 'bg-foreground-900',
      textClass: 'text-background-50',
      iconBg: 'bg-foreground-800',
    },
    {
      title: 'Kakobuy Spreadsheet — Trend Research Hub',
      subtitle: 'Editor\'s Pick',
      url: '/kakobuy-spreadsheet',
      isInternal: true,
      isImage: true,
    },
    {
      title: 'CSSBuy vs Superbuy vs Oopbuy Comparison',
      subtitle: 'Compare platforms and find the best fit for your shopping needs',
      url: '/cssbuy-spreadsheet',
      isInternal: true,
      bgClass: 'bg-background-100',
      textClass: 'text-foreground-900',
      iconBg: 'bg-background-200',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em] mb-3">
            HIPOBUY / SPREADSHEET
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            Spreadsheet Platform Guides &amp; Comparisons
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <a
            href={articles[0].url}
            className="group relative rounded-lg overflow-hidden cursor-pointer bg-foreground-900 p-6 md:p-7 min-h-[220px] flex flex-col justify-between"
          >
            <div className="w-10 h-10 rounded-full bg-foreground-800 flex items-center justify-center mb-5">
              <span className="text-sm font-bold text-background-50">HS</span>
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-heading font-medium text-background-50 mb-2 group-hover:underline">
                {articles[0].title}
              </h3>
              <p className="text-xs text-foreground-400">{articles[0].subtitle}</p>
            </div>
          </a>

          <a
            href={articles[1].url}
            className="group relative rounded-lg overflow-hidden cursor-pointer min-h-[220px]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20open%20notebook%20sketches%20and%20color%20swatches%2C%20minimal%20desk%20setup%20with%20warm%20terracotta%20accents%2C%20soft%20natural%20window%20lighting%2C%20artistic%20editorial%20photography%2C%20organic%20creative%20composition%2C%20bohemian%20design%20studio%20vibe&width=800&height=600&seq=editorial-card-v4&orientation=landscape"
              alt="Kakobuy Spreadsheet Trend Research Platform"
              title="Kakobuy Spreadsheet Guide"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="px-2.5 py-1 text-xs font-medium text-background-50 bg-foreground-900/70 rounded-full whitespace-nowrap">
                Editor&apos;s Pick
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-lg md:text-xl font-heading font-medium text-background-50 group-hover:underline">
                {articles[1].title}
              </h3>
              <p className="text-xs text-background-50/70 mt-1">{articles[1].subtitle}</p>
            </div>
          </a>

          <a
            href={articles[2].url}
            className="group rounded-lg overflow-hidden cursor-pointer bg-background-200/60 p-6 md:p-7 min-h-[220px] flex flex-col justify-between"
          >
            <div>
              <h3 className="text-lg md:text-xl font-heading font-medium text-foreground-900 mb-2 group-hover:underline">
                {articles[2].title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{articles[2].subtitle}</p>
            </div>
            <div className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-600">
              <span>Read Comparison</span>
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}